import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./auth-provider";

const Authenticated = ({ children }) => {
  const { user, profile } = useAuth();
  const location = useLocation();
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!profile) {
    return null;
  }
  return children;
};

export default Authenticated;
